import React from 'react';
import { useTranslation } from 'react-i18next';


const FooterAlt = () => {

        const { t, i18n } = useTranslation()

        return (
            <React.Fragment>
                <section className="footer-alt bg-dark pt-3 pb-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <p className="copyright text-white f-14 font-weight-light mb-0"> {new Date().getFullYear()} © JABB Consulting - Design by Jonatan</p>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    
}
export default FooterAlt;